module.exports = __webpack_public_path__ + "img/xxkw.fe6850e5.png";